<template>
  <v-dialog :value="show" persistent width="700" @input="$emit('update:show', $event)">
    <v-card>
      <v-card-title class="headline green darken-2 white--text" primary-title>
        Formulário de Qualificação LAC
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="qualificationFormHeaders"
          :items="qualificationForm || []"
          class="elevation-1"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{ props.item.question }}</td>

            <td>
              <small class="badge green" v-if="props.item.answer">
                SIM
              </small>
              <small class="badge red" v-else>
                NÃO
              </small>
            </td>

            <td>
              <small class="badge green" v-if="props.item.answerTemplate">
                Qualifica
              </small>
              <small class="badge red" v-else>
                Não
              </small>
            </td>
          </template>
          <template v-slot:no-data>
            <div class="text-xs-center">Nenhuma resposta disponível</div>
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider></v-divider>
      
      <v-card-actions>
        <v-layout justify-center>
          <v-btn 
            flat
            @click="$emit('update:show', false)"
          >
            Fechar
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'QualificationFormDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    qualificationForm: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      qualificationFormHeaders: [
        { text: 'Pergunta', value: 'question', sortable: false },
        { text: 'Resposta', value: 'answer', sortable: false },
        { text: 'Qualifica', value: 'answerTemplate', sortable: false }
      ]
    };
  }
};
</script>